import { render, staticRenderFns } from "./ThankYouTakeOut.vue?vue&type=template&id=2d1871af&scoped=true"
import script from "./ThankYouTakeOut.vue?vue&type=script&lang=js"
export * from "./ThankYouTakeOut.vue?vue&type=script&lang=js"
import style0 from "./ThankYouTakeOut.vue?vue&type=style&index=0&id=2d1871af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1871af",
  null
  
)

export default component.exports